import {
  IconAbout,
  IconAlbion,
  IconBottle,
  IconCard,
  IconChess,
  IconDice,
  IconDomino,
  IconHome,
  IconYes,
} from "shared/utils/assets";

export const ENav = {
  HOME: "HOME",
  CARD: "CARD",
  ABOUT: "ABOUT",
  YES: "YES",
  ALBION: "ALBION",
  GAME: "GAME",
  BOTTLE: "BOTTLE",
  CHESS: "CHESS",
  DOMINO: "DOMINO",
};

export const NavList = [
  { enum: ENav.HOME, src: IconHome, size: "2em" },
  { enum: ENav.CARD, src: IconCard, size: "2em" },
  { enum: ENav.ABOUT, src: IconAbout, size: "2em" },
  { enum: ENav.YES, src: IconYes, size: "3em" },
  { enum: ENav.ALBION, src: IconAlbion, size: "3em" },
  { enum: ENav.GAME, src: IconDice, size: "3em" },
  { enum: ENav.BOTTLE, src: IconBottle, size: "3em" },
  { enum: ENav.CHESS, src: IconChess, size: "3em" },
  { enum: ENav.DOMINO, src: IconDomino, size: "3em" },
];
